// extracted by mini-css-extract-plugin
export default {"root":"DisableSeoTooltip__root--2-V39","title":"DisableSeoTooltip__title--1-rB5","wrapper":"DisableSeoTooltip__wrapper--3glGp"};